import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import IntroSection from "@/components/IntroSection";
import MissionSection from "@/components/MissionSection";
import ForWhomSection from "@/components/ForWhomSection";
import OfferingsSection from "@/components/OfferingsSection";
import ImagineSection from "@/components/ImagineSection";
import OriginSection from "@/components/OriginSection";
import AboutSection from "@/components/AboutSection";
import ValuesSection from "@/components/ValuesSection";
import OltreSection from "@/components/OltreSection";
import PricingSection from "@/components/PricingSection";
import FaqSection from "@/components/FaqSection";
import CtaSection from "@/components/CtaSection";
import LightMottoSection from "@/components/LightMottoSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import Footer from "@/components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen" data-testid="homepage">
      <Navbar />
      <main>
        <HeroSection />
        <IntroSection />
        <ForWhomSection />
        <OfferingsSection />
        <ImagineSection />
        <OriginSection />
        <AboutSection />
        <ValuesSection />
        <OltreSection />
        <PricingSection />
        <TestimonialsSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
